module.exports = __webpack_public_path__ + "img/disablesixdots.90f6dbd6.svg";